<div>
    <div #chartElement style="width: 200px;  height: 200px; margin: 0 auto"></div>
</div>